import moment from 'moment';

const isSame = (dateA, dateB, granularity) => {
  return moment(dateA).isSame(dateB, granularity);
};

export default isSame;
